import type { ReactNode } from 'react'

import { StyledIconButton } from '../../../theme/components/StyledIconButton'

interface FilterToggleButtonProps<
  TFilters extends Record<string, any>,
  K extends keyof TFilters,
> {
  filterKey: K
  value: TFilters[K]
  onFilterChange: (filter: Partial<TFilters>, submit?: boolean) => void
  activeIcon: ReactNode
  inactiveIcon: ReactNode
  activeTitle: string
  inactiveTitle: string
}

export function FilterToggleButton<
  TFilters extends Record<string, any>,
  K extends keyof TFilters,
>({
  filterKey,
  value,
  onFilterChange,
  activeIcon,
  inactiveIcon,
  activeTitle,
  inactiveTitle,
}: FilterToggleButtonProps<TFilters, K>) {
  return (
    <StyledIconButton
      icon={value ? activeIcon : inactiveIcon}
      title={value ? activeTitle : inactiveTitle}
      onClick={() =>
        onFilterChange({ [filterKey]: !value } as Partial<TFilters>, true)
      }
    />
  )
}
